import { render, staticRenderFns } from "./ProgrammeCategory.vue?vue&type=template&id=2f0aa68a&scoped=true"
import script from "./ProgrammeCategory.vue?vue&type=script&lang=js"
export * from "./ProgrammeCategory.vue?vue&type=script&lang=js"
import style0 from "./ProgrammeCategory.vue?vue&type=style&index=0&id=2f0aa68a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0aa68a",
  null
  
)

export default component.exports